import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";
import { Typography } from "components/typography";

export const StyledRecipientDetails = styled(Typography)`
  padding-top: 24px;
`;

export const StyledTitle = styled(Typography)`
  padding-top: 33px;
`;

export const StyledRecipientWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding-top: 24px;
`;

export const StyledReferralInstructions = styled.div``;

export const StyledDescription = styled(Typography)`
  color: ${({ theme }) => defaultTheme.COLORS.BLACK_GREY};
`;

export const StyledDescriptionBody = styled(Typography)`
  margin: 10px 0px;
  display: block;
`;
